/**
 * @flow
 */

import { doNotSell } from '../../lib/utils';
import {
  SESSION_INIT,
  SESSION_FETCH_SUCCESS,
  SESSION_FETCH_ERROR,
  SESSION_FETCH_WISHLIST_SUCCESS
} from './actions';

const ADMIN_ROLES = ['SuperAdmin', 'Admin', 'Developer', 'Sales', 'SalesAdmin'];
const FAKE_AMPLITUDE = {
  logEvent: (eventName, eventData) => {
    console.log(`Amplitude is disabled for admins: "${eventName}", ${JSON.stringify(eventData)}`);
  },
};

const initialState = {
  loading: false,
  csrfToken: null,
  user: null,
  wishlist: null,
  amplitudeInstance: null
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case SESSION_INIT:
      return Object.assign({}, state, {
        loading: true,
        user: null
      });

    case SESSION_FETCH_SUCCESS:
      let amplitudeInstance = null;

      if (window.amplitude && !doNotSell()) {
        const { user } = action.payload;
        const signedInAsAdmin = document.cookie.split('; ').includes('signed_in_through_admin=true');

        if (signedInAsAdmin || ADMIN_ROLES.indexOf(user.role) !== -1) {
          amplitudeInstance = Object.create(FAKE_AMPLITUDE);
        }
        else {
          amplitudeInstance = window.amplitude.getInstance();
          amplitudeInstance.setUserId(user.id);
          // this makes an extra HTTP request. so we'd like to save the instance in the store for the current user
          amplitudeInstance.setUserProperties({ isHost: user.is_host, isMUM: user.memberships.length !== 0 });
        }
      }

      return Object.assign({}, state, {
        loading: false,
        user: action.payload.user,
        csrfToken: action.payload.csrfToken,
        amplitudeInstance
      });

    case SESSION_FETCH_ERROR:
      return Object.assign({}, state, {
        loading: false,
        user: null,
        amplitudeInstance: null
      });

    case SESSION_FETCH_WISHLIST_SUCCESS:
      return Object.assign({}, state, {
        wishlist: action.payload
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/session/reducer.js